import { useEffect } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from './Navbar';
import Footer from './Footer';
import { defaultLanguage, isSupportedLanguage } from '@/data/languages';

export default function LocaleLayout() {
  const { lang } = useParams();
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  const isValid = isSupportedLanguage(lang);

  useEffect(() => {
    if (!isValid) {
      navigate(`/${defaultLanguage}`, { replace: true });
      return;
    }
    if (lang && lang !== i18n.language) {
      i18n.changeLanguage(lang);
    }
  }, [lang, isValid, navigate, i18n]);

  if (!isValid) {
    return null;
  }

  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}